import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'

import api from '../services/api'
import { paramsToObject, validarCNPJ } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { colors } from '../utils/vars'
import { mCEP, mCNPJ, mVAL } from '../utils/masks'
import consultaCep from '../services/consultaCep';

const swal = withReactContent(Swal)

function Sedes(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [invalido, setInvalido] = useState(false)
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Sedes', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Sedes', 'Inclusao'))
      }

      setComboCid(await api.getComboData('cidades'))
      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/sedes?pk_sed=' + query.codigo).then(r => {
          if (r.data[0]) {
            if (r.data[0].desconto)
              r.data[0].desconto = mVAL(r.data[0].desconto * 100)
            if (r.data[0].aliquota)
              r.data[0].aliquota = mVAL(r.data[0].aliquota * 100)

            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/sedes/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/sedes/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const validaCpfCnpj = (e) => {
    e.preventDefault()
    let value = e.target.value
    setInvalido(false)
    if ((value) && (!validarCNPJ(value))) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
        html: `<p style='color: ${colors.info900}'>CNPJ Inválido</p>`,
        icon: 'warning',
      }).then(r => {
        setInvalido(true)
        document.getElementById('cnpj').focus()
      })
    }
  }

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    if (e.target.name == 'cep') {
      consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
        if (!r.data.erro) {
          auxValues.endereco = r.data.logradouro
          auxValues.complemento = r.data.complemento
          auxValues.bairro = r.data.bairro
          api.get('/cidades?descricao=' + r.data.localidade).then(res => {
            if (res.data.length > 0) {
              auxValues.fk_cid = res.data[0].pk_cid
            }
            setData(auxValues)
            swal.close()
          })
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },

            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
            icon: 'warning',
          })
        }
      })

    }
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'desconto':
      case 'aliquota':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';
        break;

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Sedes</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='100'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#083c7c"
            label="Descrição"
            variant="outlined"
            size="small"
            required
            style={{ width: 300 }}
          />

          
          <FrTextInput
            value={data.desconto || ''}
            style={{ width: 100 }}
            name="desconto"
            id="desconto"
            color="#333333"
            label="Desconto"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrSelect
            value={data.ativo || ''}
            onChange={handleChange}
            name="ativo"
            id="ativo"
            label='Ativo'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
            hidden={!updateType}
          />
          <br/>
          <FrTextInput
            maxLength='18'
            value={mCNPJ(data.cnpj)}
            onChange={handleChange}
            name="cnpj"
            id="cnpj"
            color="#389492"
            label={"CNPJ"}
            variant="outlined"
            size="small"
            onBlur={validaCpfCnpj}
            style={{ width: 160 }}
          />
          <FrTextInput
            value={data.razao_social || ''}
            style={{ width: 500 }}
            name="razao_social"
            id="razao_social"
            color="#333333"
            label="Razão Social"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <br/>
          <FrTextInput
            value={data.insc_municipal || ''}
            style={{ width: 200 }}
            name="insc_municipal"
            id="insc_municipal"
            color="#333333"
            label="Inscrição Municipal"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.fone1 || ''}
            style={{ width: 190 }}
            name="fone1"
            id="fone1"
            color="#333333"
            label="Telefone"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <br/>
          
          <FrTextInput
            value={data.cep ? mCEP(data.cep) : ''}
            style={{ width: 100 }}
            name="cep"
            id="cep"
            color="#333333"
            label="CEP"
            variant="outlined"
            size="small"
            onChange={handleChange}
            onBlur={handleCep}
          />
          <FrTextInput
            value={data.logradouro || ''}
            style={{ width: 400 }}
            name="logradouro"
            id="logradouro"
            color="#333333"
            label="Logradouro"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.numero || ''}
            style={{ width: 100 }}
            name="numero"
            id="insc_municipal"
            color="#333333"
            label="Número"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <br/>
          <FrTextInput
            value={data.complemento || ''}
            style={{ width: 200 }}
            name="complemento"
            id="complemento"
            color="#333333"
            label="Complemento"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.bairro || ''}
            style={{ width: 300 }}
            name="bairro"
            id="bairro"
            color="#333333"
            label="Bairro"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrSelect
            value={data.fk_cid || ''}
            onChange={handleChange}
            name="fk_cid"
            id="fk_cid"
            label='Cidade'
            data={comboCid}
            style={{ width: 220 }}
          />
          <br/>
          <FrTextInput
            value={data.regime || ''}
            style={{ width: 150 }}
            name="regime"
            id="regime"
            color="#333333"
            label="Regime"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.natureza || ''}
            style={{ width: 150 }}
            name="natureza"
            id="natureza"
            color="#333333"
            label="Natureza"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <br/>
          <FrSelect
            value={data.optante_simples || ''}
            onChange={handleChange}
            name="optante_simples"
            id="optante_simples"
            label='Optante Simples'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
          />
          <FrSelect
            value={data.enviar_pf_email || ''}
            onChange={handleChange}
            name="enviar_pf_email"
            id="enviar_pf_email"
            label='Enviar Email PF'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
          />
          <FrSelect
            value={data.enviar_pj_email || ''}
            onChange={handleChange}
            name="enviar_pj_email"
            id="enviar_pj_email"
            label='Enviar Email PJ'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
          />
          <FrSelect
            value={data.imprimir || ''}
            onChange={handleChange}
            name="imprimir"
            id="imprimir"
            label='Imprimir'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
          />
          <FrSelect
            value={data.producao || ''}
            onChange={handleChange}
            name="producao"
            id="producao"
            label='Produção'
            data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
            style={{ width: 140 }}
          />
          <br/>
          <FrTextInput
            value={data.numero_serie_certificado || ''}
            style={{ width: 250 }}
            name="numero_serie_certificado"
            id="numero_serie_certificado"
            color="#333333"
            label="Nº Série Certificado"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.senha_certificado || ''}
            style={{ width: 250 }}
            name="senha_certificado"
            id="senha_certificado"
            color="#333333"
            label="Senha Certificado"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          
          <br/>
          <FrTextInput
            value={data.numero_primeiro_lote || ''}
            style={{ width: 250 }}
            name="numero_primeiro_lote"
            id="numero_primeiro_lote"
            color="#333333"
            label="Nº Primeiro Lote"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          <FrTextInput
            value={data.aliquota || ''}
            style={{ width: 100 }}
            name="aliquota"
            id="aliquota"
            color="#333333"
            label="Alíquota"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />
          
          
          
          <FrTextInput
            value={data.senha_prefeitura || ''}
            style={{ width: 200 }}
            name="senha_prefeitura"
            id="senha_prefeitura"
            color="#333333"
            label="Senha Prefeitura"
            variant="outlined"
            size="small"
            onChange={handleChange}
          // onBlur={handleBlur}
          />


        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Sedes;
